<template>
    <BreadCrumb PageTitle="Modifier une question" />
    <EditQuestion />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditQuestion from "@/components/Question/EditQuestion.vue";
  
    export default defineComponent({
      name: "EditQuestionPage",
      components: {
        BreadCrumb,
        EditQuestion,
      },
    });
  </script>